<template>
    <div class="eFPPopup-div1" :style="{'top': top + 'px', 'left': left + 'px'}">
        <span>{{popupTissue}}</span>
    </div>
</template>

<script>
    export default {
        name: 'eFPPopup',
        props: ["left", 'top', 'popupTissue'],
        data () {
            return {

            }
        },
        mounted() {
            
        },
        methods: {
            
        },
    }
</script>

<style>

    .eFPPopup-div1 {
        width: 120px;
        /* height: 50px; */
        background: #99CCFF;
        position: absolute;
        border-radius:5px;
        text-align: center;
        z-index:999;
    }

</style>
